const BARTER_STATE_LABEL = {
    proposal: 'návrh',
    valid: 'platná',
    postponed: 'odložená',
    finished: 'ukončená'
}

export default BARTER_STATE_LABEL